import { format } from 'date-fns';
import { convertUTCToTimezone } from '@betgames/bg-tools';

export const convertToPartnerDateTime = (
    utcTime: number,
    timezone: number,
    locale: string,
): string => {
    const timezoneSuffix = timezone === 0 ? ' GMT' : '';

    const convertedTimestamp = convertUTCToTimezone(utcTime, timezone);

    return `${format(convertedTimestamp, locale === 'lt' ? 'PPPp' : 'PPp')}${timezoneSuffix}`;
};
